export var CALC_CONFIG = {
    minutosPorCliente: 3,
    diasPorMes: 26,
    custoHora: 80,
    economiaPercentual: 0.85,
};
export var PLANOS_CONFIG = [
    {
        id: 'starter',
        name: "Starter",
        limite: 5,
        price: 97,
        priceLabel: "R$ 97",
        clients: "Até 5 clientes",
        dashboards: "Para quem começou a escalar",
        highlight: false,
        details: "Atualização a cada 1h. Pare de perder tempo.",
    },
    {
        id: 'intermediario',
        name: "Intermediário",
        limite: 10,
        price: 197,
        priceLabel: "R$ 197",
        clients: "Até 10 clientes",
        dashboards: "Automatize a operação inteira",
        highlight: true,
        details: "Atualização a cada 1h. Controle total.",
    },
    {
        id: 'agencia',
        name: "Agência",
        limite: 20,
        price: 397,
        priceLabel: "R$ 397",
        clients: "Até 20 clientes",
        dashboards: "Crescimento sem risco",
        highlight: false,
        details: "Atualização a cada 1h. Controle REAL.",
    },
    {
        id: 'enterprise',
        name: 'Enterprise',
        clients: 'Para operações avançadas e volumes elevados de clientes',
        priceLabel: 'Personalizado',
        dashboards: 'Configuração sob medida',
        details: 'O VisionCockpit Enterprise é um plano personalizado, criado para gestores e agências com grandes volumes de contas, necessidades específicas de monitoramento e maior demanda de infraestrutura.',
        highlight: false,
        isEnterprise: true, // ✅ Flag para identificar o plano Enterprise
        features: [
            'Volume elevado de clientes',
            'Configuração sob medida',
            'Frequência de atualização personalizada',
            'Suporte direto com o time'
        ]
    }
];
export var PAIN_POINTS = [
    {
        title: "Campanha travada há horas",
        desc: "Você descobre quando o cliente liga nervoso.",
        iconType: "alert"
    },
    {
        title: "Saldo acabou de madrugada",
        desc: "E você só vê de manhã, depois de perder vendas.",
        iconType: "clock"
    },
    {
        title: "Performance caindo",
        desc: "Você perde dias até notar o problema real.",
        iconType: "trending"
    },
];
export var FEATURES = [
    {
        title: "Todos os clientes em uma tela",
        desc: "Google Ads, Facebook Ads e Instagram. Lado a lado. Atualização automática 24/7.",
        iconType: "chart"
    },
    {
        title: "Alerta no WhatsApp antes da crise",
        desc: "Saldo zerando? Campanha parada? Você resolve ANTES do cliente perceber.",
        iconType: "whatsapp"
    },
    {
        title: "Configure em 2 minutos",
        desc: "Literalmente isso. Conecta, seleciona clientes, pronto. Acabou a burocracia.",
        iconType: "bolt"
    },
    {
        title: "Dashboards que impressionam",
        desc: "Relatórios visuais prontos em segundos. Sem planilha manual, sem perder horas.",
        iconType: "zap"
    },
];
export var TESTIMONIALS = [
    {
        name: "Jafé Tavares",
        role: "Diretor na XVOX Digital",
        text: "Economiza horas por semana. Atendo mais clientes sem perder qualidade. Nunca mais fiquei preso em relatórios intermináveis.",
        avatar: "/static/frontend/img/clientes/jafe-tavares.png",
    },
    {
        name: "Matheus Lopes",
        role: "Empreendedor na L3 Systems",
        text: "Em minutos já estava monitorando. Nunca mais tive medo de campanha travar. Foi um alívio parar de me preocupar.",
        avatar: "/static/frontend/img/clientes/matheus-lopes.png",
    },
    {
        name: "Felipe Rocha",
        role: "Analista de Performance",
        text: "O Starter já resolve para clientes pequenos. Cresci sem medo. Me trouxe a tranquilidade que eu precisava.",
        avatar: "/static/frontend/img/clientes/felipe-rocha.png",
    },
];
export var FAQS = [
    {
        q: "Preciso de cartão para testar?",
        a: "Não. Só cria a conta e usa. 14 dias grátis, sem cartão, sem compromisso.",
    },
    {
        q: "O que posso monitorar?",
        a: "Google Ads, Facebook Ads e Instagram. Novas plataformas em breve.",
    },
    {
        q: "Posso migrar do plano de teste para pago?",
        a: "Sim. Em 2 cliques. Migração instantânea, sem perder dados.",
    },
    {
        q: "Quanto tempo para configurar?",
        a: "Menos de 2 minutos. Conecta as contas, seleciona clientes, pronto.",
    },
    {
        q: "É para quem exatamente?",
        a: "Gestores de tráfego e agências que não querem mais operar no escuro.",
    },
    {
        q: "Quanto tempo economizo por mês?",
        a: "Entre 4 e 10 horas. Tempo que você pode usar para pegar mais clientes, otimizar de verdade, ganhar mais dinheiro.",
    },
];
// Funções de cálculo centralizadas
export var calcularTempoDesperdicado = function (clientes) {
    return Math.round((clientes * CALC_CONFIG.minutosPorCliente * CALC_CONFIG.diasPorMes) / 60);
};
export var calcularCustoOperacional = function (clientes) {
    var horas = calcularTempoDesperdicado(clientes);
    return Math.round(horas * CALC_CONFIG.custoHora);
};
export var calcularEconomiaHoras = function (clientes) {
    return Math.round(calcularTempoDesperdicado(clientes) * CALC_CONFIG.economiaPercentual);
};
export var calcularEconomiaDinheiro = function (clientes) {
    return Math.round(calcularCustoOperacional(clientes) * CALC_CONFIG.economiaPercentual);
};
export var calcularROI = function (clientes) {
    var economia = calcularEconomiaDinheiro(clientes);
    var plano = PLANOS_CONFIG.find(function (p) { return clientes <= p.limite; }) || PLANOS_CONFIG[PLANOS_CONFIG.length - 1];
    return Math.round((economia / plano.price) * 100);
};
export var CTA_VARIANTS = {
    hero: "Comece agora - 14 dias grátis",
    middle: "Quero parar de perder tempo",
    calculator: "Quero recuperar essas horas",
    plans: "Criar conta grátis agora",
    final: "Teste grátis por 14 dias - sem cartão"
};
